import React, { createContext, useCallback, useState } from 'react'
import { getReleaseDisplayName } from '../../Constants/ReleaseDisplayNames'

function getPublicationId(pub) {
  return pub?.publicationId ?? pub?.id ?? null
}

/**
 * Build map publicationId -> display name.
 * - isGgcAdmin: use publication's own displayName/name from API (year/month as returned by backend).
 * - non-admin: use FE release labels (e.g. "2025 YE Full Granularity", "2024 YE Full Granularity").
 */
export function buildPublicationDisplayNamesMap(publications, isGgcAdmin = false) {
  const list = Array.isArray(publications)
    ? publications
    : (publications?.content ?? publications?.publications ?? [])
  const map = {}
  list.forEach((pub) => {
    const id = getPublicationId(pub)
    if (id != null) {
      map[String(id)] = isGgcAdmin
        ? (pub.displayName ?? pub.name ?? '')
        : getReleaseDisplayName(pub)
    }
  })
  return map
}

const defaultValue = {
  publicationDisplayNamesByPublicationId: {},
  setPublications: () => {}
}

export const PublicationDisplayNamesContext = createContext(defaultValue)

export function PublicationDisplayNamesProvider({ children }) {
  const [publicationDisplayNamesByPublicationId, setMap] = useState({})

  const setPublications = useCallback((publications, isGgcAdmin = false) => {
    setMap(buildPublicationDisplayNamesMap(publications, isGgcAdmin))
  }, [])

  const value = {
    publicationDisplayNamesByPublicationId,
    setPublications
  }

  return (
    <PublicationDisplayNamesContext.Provider value={value}>
      {children}
    </PublicationDisplayNamesContext.Provider>
  )
}

export function getDisplayNameByPublicationId(contextValue, publicationId) {
  if (publicationId == null || !contextValue?.publicationDisplayNamesByPublicationId) return undefined
  return contextValue.publicationDisplayNamesByPublicationId[String(publicationId)]
}
